import { createReducer, on } from '@ngrx/store';
import { UiActions } from './ui.actions';
import { UIState, initialUiState } from './ui.state';

export const uiReducer = createReducer(
  initialUiState,
  on(UiActions.requestStarted, (state): UIState => ({
    ...state,
    activeRequests: state.activeRequests + 1,
  })),
  on(UiActions.requestCompleted, (state): UIState => ({
    ...state,
    activeRequests: Math.max(0, state.activeRequests - 1),
  })),
  on(UiActions.showError, (state, { message }): UIState => ({ ...state, errorMessage: message })),
  on(UiActions.showSuccess, (state, { message }): UIState => ({
    ...state,
    successMessage: message,
  })),
  on(UiActions.clearMessages, (state): UIState => ({
    ...state,
    errorMessage: null,
    successMessage: null,
  })),
);
